const VATNumberValidation = function VATNumberValidation(taxnumber) {
  const pattern = "[4]{1}[0-9]{9}";

  var reIsValidLength = new RegExp(`^${pattern}$`);

  if (reIsValidLength.test(taxnumber)) {
    return true;
  }

  return false;
};

export default VATNumberValidation;

